import { Box } from "@chakra-ui/react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Avatar } from "../avatar/Avatar";
import { useNavigate } from "react-router-dom";
import { useGetAccounts } from "./useGetAccounts";

const border = "1px solid #CBD5E0";

interface MarkdownRendererProps {
  children: string;
}

export const MarkdownRenderer = ({ children }: MarkdownRendererProps) => {
  const accounts = useGetAccounts();
  const navigate = useNavigate();
  return (
    <Box display={"flex"} flexDir={"column"}>
      <Markdown
        remarkPlugins={[remarkGfm]}
        components={{
          table(props) {
            return (
              <table
                style={{
                  border,
                  borderCollapse: "collapse",
                }}
              >
                {props.children}
              </table>
            );
          },
          td(props) {
            return (
              <td style={{ textAlign: "center", border }}>{props.children}</td>
            );
          },
          th(props) {
            return <th style={{ border }}>{props.children}</th>;
          },
          li(props) {
            const { children } = props;
            return (
              <Box marginTop={2} marginBottom={2}>
                • {children}
              </Box>
            );
          },
          hr(props) {
            const { children } = props;
            return (
              <hr style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                {children}
              </hr>
            );
          },
          p(props) {
            return <div>{props.children}</div>;
          },
          strong(props) {
            const { children } = props;
            for (const account of accounts) {
              if (
                children ===
                `@${account.fName.replaceAll(
                  " ",
                  ""
                )}${account.lName.replaceAll(" ", "")}`
              ) {
                return (
                  <Box display={"flex"} justifyContent={"flex-start"}>
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      border={"1px solid teal"}
                      borderRadius={"25px"}
                      height={"45px"}
                      paddingLeft={"2px"}
                      paddingRight={"22.5px"}
                      marginTop={1}
                      marginBottom={1}
                      width={"auto"}
                    >
                      <Avatar
                        config={account.avatarConfig}
                        round={true}
                        width={"40px"}
                        height={"40px"}
                      />
                      <Box
                        fontWeight={"bold"}
                        color={"teal"}
                        marginLeft={2}
                        onClick={() => {
                          navigate(`/account/${account.id}`);
                        }}
                      >
                        @{account.fName} {account.lName}
                      </Box>
                    </Box>
                  </Box>
                );
              }
            }
            return <strong>{children}</strong>;
          },
        }}
      >
        {children}
      </Markdown>
    </Box>
  );
};
